module.exports = __webpack_public_path__ + "static/img/guide_step_3.8ec2007c.png";